/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_All_Snapshots_TakenInputs */

const vi_stocktake_all_snapshots_taken = /** @type {(inputs: Stocktake_All_Snapshots_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả chốt sổ approved của loại lô này đều đã có phiếu kiểm. Vào Chốt sổ để tạo chốt sổ mới.`)
};

/**

* @param {Stocktake_All_Snapshots_TakenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_all_snapshots_taken = /** @type {((inputs?: Stocktake_All_Snapshots_TakenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_All_Snapshots_TakenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_all_snapshots_taken(inputs)
});